// extracted by mini-css-extract-plugin
export default {"dialogHeaderCont":"BglDialogStyles_dialogHeaderCont__aB-Zb","dialogHeader":"BglDialogStyles_dialogHeader__P-9PO"};